import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface UserAvatarProps {
  photoUrl: string | null;
  firstName: string;
  lastName: string;
  size?: number;
  className?: string;
}

export function UserAvatar({ photoUrl, firstName, lastName, size = 36, className = "" }: UserAvatarProps) {
  const [signedUrl, setSignedUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
    if (photoUrl) {
      supabase.storage
        .from("profile-photos")
        .createSignedUrl(photoUrl, 3600)
        .then(({ data }) => {
          if (data?.signedUrl) setSignedUrl(data.signedUrl);
          else setError(true);
        })
        .catch(() => setError(true));
    } else {
      setSignedUrl(null);
    }
  }, [photoUrl]);

  const initials = `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase() || "?";

  return (
    <div
      className={`rounded-full bg-nursly-forest flex items-center justify-center overflow-hidden shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      {signedUrl && !error ? (
        <img
          src={signedUrl}
          alt={`${firstName} ${lastName}`}
          className="h-full w-full object-cover"
          onError={() => setError(true)}
        />
      ) : (
        <span
          className="text-white font-body font-medium"
          style={{ fontSize: size * 0.38 }}
        >
          {initials}
        </span>
      )}
    </div>
  );
}
